import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { checkAccessToken } from '@/utils/handle-authentication';
import { handleAPIError } from '@/utils/handle-api-error';
import { projectExportXmlAction } from '@/redux/actions/project-export';
import { projectExportXml, TProjectExportXmlResponse } from '@/services/api/project-export';

// FUNCTION
export function* projectExportXmlSaga(action: ActionType<typeof projectExportXmlAction.request>): Generator {
  const { companyId, projectId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(projectExportXml, companyId, projectId);
    const projectExportXmlResponse: TProjectExportXmlResponse = response as TProjectExportXmlResponse;
    yield put(projectExportXmlAction.success(projectExportXmlResponse));
    successCallback?.(projectExportXmlResponse);
  } catch (err) {
    handleAPIError(err, 'Error.getProjectXMLFileError');
    yield put(projectExportXmlAction.failure(err));
    failedCallback?.(err);
  }
}
